import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { IntegrationsHttpClient } from '@recruitee/integrations/http';

import { EnabledIntegrationKindsActions } from './enabled-integration-kinds.store';

@Injectable({ providedIn: 'root' })
export class EnabledIntegrationKindsEffects {
  public fetch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EnabledIntegrationKindsActions.fetch),
      switchMap(() =>
        this.integrationsHttpClient.loadEnabledIntegrationKinds().pipe(
          map(kinds => EnabledIntegrationKindsActions.fetchSuccess({ payload: kinds })),
          catchError((error: HttpErrorResponse) =>
            of(EnabledIntegrationKindsActions.fetchFailed({ payload: error })),
          ),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private integrationsHttpClient: IntegrationsHttpClient) {}
}
